import { GREEN } from '../Theme/palette';
import { Button, ConfigProvider } from 'antd';
import { ButtonProps } from 'antd/es/button';
import React from 'react';

export const SuccessButton: React.FC<ButtonProps> = (props) => (
  <ConfigProvider
    theme={{
      components: {
        Button: {
          colorPrimary: GREEN.badge,
          colorPrimaryHover: GREEN.tag,
          colorPrimaryActive: GREEN.active,
        },
      },
    }}
  >
    <Button type="primary" {...props} />
  </ConfigProvider>
);
